import { showMessage } from 'utilities/Utils';
import { routes } from '../../app/routes';
import * as GuestChatIcons from 'assets/modules/guest-chat';
import { isLocalProd, isProd } from '../../base/APIClient';
import { getFormattedDate } from '../../utilities/DateUtils';
import { doMonthFormat } from 'constants';

const GUEST_CHAT_FIREBASE_QA_CONFIG = {
  apiKey: 'AIzaSyCrBvpNrgXf1Nzllncgql0NCxEJBnX12lA',
  authDomain: 'ingo-chatbot.firebaseapp.com',
  databaseURL: 'https://ingo-chatbot.firebaseio.com',
  projectId: 'ingo-chatbot',
  storageBucket: 'ingo-chatbot.appspot.com',
  messagingSenderId: '821242665697',
  appId: '1:821242665697:web:2d0a084f96568517b875a0',
};

export const GUEST_CHAT_FIREBASE_PROD_CONFIG = {
  apiKey: 'AIzaSyDjN1gUR_0iD3mvTurNmCfoz23hPd8YWF8',
  authDomain: 'ingo-chat.firebaseapp.com',
  databaseURL: 'https://ingo-chat.firebaseio.com',
  projectId: 'ingo-chat',
  storageBucket: 'ingo-chat.appspot.com',
  messagingSenderId: '589110324741',
  appId: '1:589110324741:web:68c9f0df263576bc2b766c',
};

// NOTE: When .env.local is pointing to in.goibibo.com, config isprod should be true or custom
// token error will come.
export const firebaseConfig =
  isProd || isLocalProd
    ? GUEST_CHAT_FIREBASE_PROD_CONFIG
    : GUEST_CHAT_FIREBASE_QA_CONFIG;

const arrayMove = (filterArray, fromIndex, toIndex) => {
  const arr = filterArray;
  const element = arr[fromIndex];
  arr.splice(fromIndex, 1);
  arr.splice(toIndex, 0, element);
  return arr;
};

export const getConversationFilters = (
  STRINGS,
  currentFilter,
  isChatFilterDropDown,
) => {
  const quickFiltersArray = [
    // { label: STRINGS.FILTERS.ALL, value: routes.guestchat.all },
    {
      label: STRINGS.FILTERS.BKG_REQUEST,
      value: routes.guestchat.bookingRequest,
    },
    { label: STRINGS.FILTERS.UNREAD, value: routes.guestchat.unread },
    {
      label: STRINGS.FILTERS.UNREPLIED,
      value: routes.guestchat.unreplied,
    },
    { label: STRINGS.FILTERS.STARRED, value: routes.guestchat.starred },
    {
      label: STRINGS.FILTERS.ARCHIVED,
      value: routes.guestchat.archived,
    },
  ];
  if (isChatFilterDropDown) {
    switch (currentFilter) {
      case routes.guestchat.bookingRequest:
        return quickFiltersArray;
      case routes.guestchat.unread:
        return arrayMove(quickFiltersArray, 1, 0);
      case routes.guestchat.unreplied:
        return arrayMove(quickFiltersArray, 2, 0);
      case routes.guestchat.starred:
        return arrayMove(quickFiltersArray, 3, 0);
      case routes.guestchat.archived:
        return arrayMove(quickFiltersArray, 4, 0);
      default:
        return quickFiltersArray;
    }
  } else {
    return quickFiltersArray;
  }
};

export const getGroupChatConversationFilters = (
  STRINGS,
  currentFilter,
  isChatFilterDropDown,
) => {
  const quickFiltersArray = [
    // { label: STRINGS.FILTERS.ALL, value: routes.groupchat.all },
    {
      label: STRINGS.FILTERS.BKG_REQUEST,
      value: routes.groupchat.bookingRequest,
    },
    { label: STRINGS.FILTERS.UNREAD, value: routes.groupchat.unread },
    {
      label: STRINGS.FILTERS.UNREPLIED,
      value: routes.groupchat.unreplied,
    },
    { label: STRINGS.FILTERS.STARRED, value: routes.groupchat.starred },
    {
      label: 'Archived',
      value: routes.groupchat.archived,
    },
  ];
  if (isChatFilterDropDown) {
    switch (currentFilter) {
      case routes.groupchat.bookingRequest:
        return quickFiltersArray;
      case routes.groupchat.unread:
        return arrayMove(quickFiltersArray, 1, 0);
      case routes.groupchat.unreplied:
        return arrayMove(quickFiltersArray, 2, 0);
      case routes.groupchat.starred:
        return arrayMove(quickFiltersArray, 3, 0);
      case routes.groupchat.archived:
        return arrayMove(quickFiltersArray, 4, 0);
      default:
        return quickFiltersArray;
    }
  } else {
    return quickFiltersArray;
  }
};

export const filterUrlMap = {
  [routes.guestchat.all]: 'all',
  [routes.guestchat.starred]: 'starred',
  [routes.guestchat.unreplied]: 'unreplied',
  [routes.guestchat.unread]: 'unread',
  [routes.guestchat.bookingRequest]: 'bookingRequest',
  [routes.guestchat.archived]: 'archived',
};

export const groupChatFilterUrlMap = {
  [routes.groupchat.all]: 'all',
  [routes.groupchat.starred]: 'starred',
  [routes.groupchat.unreplied]: 'unreplied',
  [routes.groupchat.unread]: 'unread',
  [routes.groupchat.bookingRequest]: 'bookingRequest',
  [routes.groupchat.archived]: 'archived',
};

export const RED_STATUS_LIST = [
  'BOOKING REJECTED',
  'BOOKING FAILED',
  'REQUEST WITHDRAWN',
  'INVITATION WITHDRAWN',
  'BOOKING CANCELLED',
];

export const GREEN_STATUS_LIST = [
  'BOOKING CONFIRMED',
  'Booking Confirmed',
  'REQUEST APPROVED',
  'Confirmed',
];

export const PRIMARY_STATUS_LIST = [
  'AWAITING HOST CONFIRMATION',
  'PRE-APPROVED BY HOST',
];

export const INQUIRY_STATUS_LIST = [
  'ENQUIRY',
  'REQUEST EXPIRED',
  'INVITATION EXPIRED',
];

export const PREV_BOOKING_PRIMARY_STATUS = [
  'pending',
  'rtb_request',
  'booking_request',
  'host_initiated',
  'invite_to_book',
  'guest_initiated',
  'bypass_inventory',
];

export const PREV_BOOKING_RTB_STATUS = [
  'pending',
  'rtb_request',
  'booking_request',
  'guest_initiated',
];

export const PREV_BOOKING_GREEN_STATUS = [
  'accepted',
  'booking_created',
  'booking_confirmed',
  'Confirmed',
  'confirmed',
];

export const PREV_BOOKING_RED_STATUS = [
  'interim_call_done',
  'rejected',
  'expired',
  'withdrawn_request',
  'booking_failed',
  'rtb_expired',
  'rtb_rejected',
  'invite_expired',
  'invite_withdrawn',
  'rtb_withdrawn',
  'booking_cancelled',
];

export const ACTIVE_BOOKINGS_INVITE_CTA_STATUS = [
  'rejected',
  'rtb_rejected',
  'rtb_expired',
  'invite_expired',
  'invite_withdrawn',
];

export const getBookingCardStatusColor = status => {
  if (PREV_BOOKING_GREEN_STATUS.includes(status)) {
    return 'status-green';
  } else if (PREV_BOOKING_PRIMARY_STATUS.includes(status)) {
    return 'status-primary';
  } else if (PREV_BOOKING_RED_STATUS.includes(status)) {
    return 'status-red';
  }
  return 'status-text';
};

export const BOOKING_STATUS_CREATE_INVITE_LIST = [
  'rtb_rejected',
  'rtb_expired',
  'invite_expired',
  'invite_withdrawn',
  'booking_failed',
];

export const BOOKING_DETAILS_INVITE = [
  'invite_to_book',
  'invite_expired',
  'invite_withdrawn',
];

export const BOOKING_DETAILS_REQUEST = [
  'rtb_request',
  'rtb_rejected',
  'rtb_expired',
  'rtb_withdrawn',
];

export const CONVERSATION_LIST_LIMIT = 10;
export const MESSAGES_LIMIT = 10;
export const firestorePath = {
  chatbotHost: 'CHATBOT-HOST',
  sessions: 'Sessions',
  messageCollection: 'MessageCollection',
};
export const eventCategory = 'web_ingochat';
export const dateStripFormat = 'dddd, D MMM';
export const dateDisplayFormat = 'DD MMM, YYYY';
export const apiDateFormat = 'YYYY-MM-DD';
export const timeFormat = 'LT';
export const RTBTimeFormat = 'hh:mm a, DD MMM YYYY';
export const OPEN_CHAT_STATUS = 'OPEN';
export const userType = {
  HOST: 'HOST',
  CUSTOMER: 'CUSTOMER',
};
export const onlyAlphabetsRegex = /^[A-Z]+$/i;
export const alphanumericRegex = /^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$/;
export const onlyDigitsRegex = /^[0-9]+$/;
export const chatsType = {
  FIRST: 'first_chat',
  BLOCKED: 'blocked_chat',
  CLOSED: 'closed_chat',
  MERGED: 'merged_chat',
  MMTBLACK: 'mmt_black_chat',
  GOTRIBE: 'go_tribe_chat',
};
// TODO: Hack to tell all the GI bookings start with HTL. To remove in future
// Added after discussion with Praneet
const GIBkgIdRegex = /^HTL/i;
export const domains = {
  GI: 'GI',
  MMT: 'MMT',
};
const channels = {
  MYRA: 'MYRA',
  GIA: 'GIA',
};
export const GIA_MYRA_CHAT_STATUS = {
  CLOSED: 'CLOSED',
  OPEN: 'OPEN',
};
export const fullDomainNames = {
  MMT: 'makemytrip',
  GI: 'goibibo',
};

export const messageType = {
  PII_IN_MESSAGE: 'PII_IN_MESSAGE',
  PROFANITY_IN_MESSAGE: 'PROFANITY_IN_MESSAGE',
};
export const programType = {
  MMT_BLACK: 'MMT BLACK',
  GO_TRIBE: 'GO TRIBE',
};

export const segments = {
  MMT_BLACK: 'mmtblack',
  GO_TRIBE: 'gotribe',
};

export const themeColors = {
  positive: '#30a960',
  negative: '#f06159',
  neutral: '#212121',
};
export const googleMapsLocationLink = 'https://maps.google.com/?q=';
export const locationThumbnailUrl =
  'https://gos3.ibcdn.com/4894f1c47b8111eb81ed0242ac110009.png';
export const requestReviewMessage =
  'We hope you had a pleasant stay. Please give us a review on the link shared by __domain__';

export const childAgeOptions = [
  { label: '<=1', value: 1 },
  { label: '2', value: 2 },
  { label: '3', value: 3 },
  { label: '4', value: 4 },
  { label: '5', value: 5 },
  { label: '6', value: 6 },
  { label: '7', value: 7 },
  { label: '8', value: 8 },
  { label: '9', value: 9 },
  { label: '10', value: 10 },
  { label: '11', value: 11 },
  { label: '12', value: 12 },
];
export const ITB_EXPIY_TIME = 48;

export const ADULT_START_AGE = 13;
export const CHILD_START_AGE = 12;

export const getBookingDomain = bkgId => {
  const isGIBkg = GIBkgIdRegex.test(bkgId);
  const domain = isGIBkg ? domains.GI : domains.MMT;
  return domain;
};
export const getChannel = channel => {
  let domain = '';
  if (channel === channels.MYRA) {
    domain = domains.MMT;
  } else if (channel === channels.GIA) {
    domain = domains.GI;
  }
  return domain;
};
export function getTimeInfo(time) {
  // Input in Seconds and output will be date if not today(e.g 23 Feb). If today, output will be time (e.g 12:53 am)
  const dateTimeInStr = getFormattedDate(
    new Date(time.seconds * 1000),
    doMonthFormat,
  );
  const todayStr = getFormattedDate(new Date(), doMonthFormat);
  const dateTime =
    dateTimeInStr === todayStr
      ? getFormattedDate(time.seconds * 1000, timeFormat)
      : dateTimeInStr;
  return dateTime;
}

export function logStaffUserError(STRINGS) {
  showMessage({
    type: 'error',
    show: true,
    message: STRINGS.ERRORS.STAFF_USER,
  });
}

export const rtbButtonTypes = {
  DECLINE: 'DECLINE',
  WITHDRAW: 'WITHDRAW',
};

export const UNIFIED_STATUSES = {
  RTB_AWAITING: 'AWAITING HOST CONFIRMATION',
  RTB_ACCEPTED: 'REQUEST APPROVED',
  RTB_REJECTED: 'BOOKING REJECTED',
  RTB_CONFIRMED: 'BOOKING CONFIRMED',
  OLD_RTB_CONFIRMED: 'confirmed',
  RTB_EXPIRED: 'REQUEST EXPIRED',
  RTB_FAILED: 'BOOKING FAILED',
  RTB_WITHDRAWN: 'REQUEST WITHDRAWN',
  ITB_SENT: 'PRE-APPROVED BY HOST',
  ITB_WITHDRAWN: 'INVITATION WITHDRAWN',
  ITB_EXPIRED: 'INVITATION EXPIRED',
  //TODO: The below ones are new
  RTB_CANCELLED: 'BOOKING CANCELLED',
  ENQUIRY: 'ENQUIRY',
};

export const getMappedRTBStatus = STRINGS => {
  const AllStatus = STRINGS.RTB_ITB_STATUSES;

  return {
    [UNIFIED_STATUSES.RTB_AWAITING]: AllStatus.RTB_AWAITING,
    [UNIFIED_STATUSES.RTB_ACCEPTED]: AllStatus.RTB_ACCEPTED,
    [UNIFIED_STATUSES.RTB_REJECTED]: AllStatus.RTB_REJECTED,
    [UNIFIED_STATUSES.RTB_CONFIRMED]: AllStatus.RTB_CONFIRMED,
    [UNIFIED_STATUSES.RTB_EXPIRED]: AllStatus.RTB_EXPIRED,
    [UNIFIED_STATUSES.RTB_FAILED]: AllStatus.RTB_FAILED,
    [UNIFIED_STATUSES.RTB_WITHDRAWN]: AllStatus.RTB_WITHDRAWN,
    [UNIFIED_STATUSES.ITB_SENT]: AllStatus.ITB_SENT,
    [UNIFIED_STATUSES.ITB_WITHDRAWN]: AllStatus.ITB_WITHDRAWN,
    [UNIFIED_STATUSES.ITB_EXPIRED]: AllStatus.ITB_EXPIRED,
    [UNIFIED_STATUSES.RTB_CANCELLED]: AllStatus.RTB_CANCELLED,
  };
};

export const GIA_MYRA_CHAT_TID = {
  TEXT: 'TEXT',
  HTML: 'HTML',
  // RTB = Request to Book
  RTB_AWAITING: 'myra-cards.rtb_awaiting_host_confirmation',
  RTB_ACCEPTED: 'myra-cards.rtb_accepted',
  RTB_REJECTED: 'myra-cards.rtb_booking_rejected',
  RTB_CONFIRMED: 'myra-cards.rtb_booking_confirmed',
  RTB_EXPIRED: 'myra-cards.rtb_expired',
  RTB_FAILED: 'myra-cards.rtb_booking_failed',
  RTB_WITHDRAWN: 'myra-cards.rtb_withdrawn',
  // ITB = Invite to Book
  ITB_SENT: 'myra-cards.rtb_booking_pre_approved',
  ITB_WITHDRAWN: 'myra-cards.itb_withdrawn',
  ITB_EXPIRED: 'myra-cards.itb_expired',
};

export const TID_INFO_MAP = STRINGS => {
  const CARD_STATUS = STRINGS.CARD_STATUS;
  return {
    [GIA_MYRA_CHAT_TID.RTB_AWAITING]: {
      iconSrcUrl: GuestChatIcons.RequestReceivedIcon,
      iconAlt: 'request-received-icon',
      className: 'yellow-card',
      status: CARD_STATUS.RTB_AWAITING,
      fromUserType: userType.CUSTOMER,
      cardMsg: STRINGS.RTB.RTB_RECEIVED_MSG,
    },
    [GIA_MYRA_CHAT_TID.RTB_ACCEPTED]: {
      iconSrcUrl: GuestChatIcons.RequestApprovedIcon,
      iconAlt: 'request-approved-icon',
      className: 'green-card',
      status: CARD_STATUS.RTB_ACCEPTED,
      fromUserType: userType.HOST,
      cardMsg: STRINGS.RTB.RTB_APPROVED_MSG,
    },
    [GIA_MYRA_CHAT_TID.RTB_REJECTED]: {
      iconSrcUrl: GuestChatIcons.BookingFailedIcon,
      iconAlt: 'request-declined-icon',
      className: 'red-card',
      status: CARD_STATUS.RTB_REJECTED,
      fromUserType: userType.HOST,
      cardMsg: STRINGS.RTB.RTB_DECLINED_MSG,
    },
    [GIA_MYRA_CHAT_TID.RTB_CONFIRMED]: {
      iconSrcUrl: GuestChatIcons.RequestApprovedIcon,
      iconAlt: 'request-confimed-icon',
      className: 'green-card',
      status: CARD_STATUS.RTB_CONFIRMED,
      fromUserType: userType.HOST,
      cardMsg: STRINGS.RTB.RTB_CONFIRMED_MSG,
    },
    [GIA_MYRA_CHAT_TID.RTB_EXPIRED]: {
      iconSrcUrl: GuestChatIcons.RequestExpiredMiniIcon,
      iconAlt: 'request-expired-icon',
      className: 'grey-card',
      status: CARD_STATUS.RTB_EXPIRED,
      fromUserType: userType.HOST,
      cardMsg: STRINGS.RTB.RTB_EXPIRED_MSG,
    },
    [GIA_MYRA_CHAT_TID.RTB_FAILED]: {
      iconSrcUrl: GuestChatIcons.BookingFailedIcon,
      iconAlt: 'booking-failed-icon',
      className: 'red-card',
      status: CARD_STATUS.RTB_FAILED,
      fromUserType: userType.HOST,
      cardMsg: STRINGS.RTB.RTB_FAILED_MSG,
    },
    [GIA_MYRA_CHAT_TID.RTB_WITHDRAWN]: {
      iconSrcUrl: GuestChatIcons.BookingFailedIcon,
      iconAlt: 'booking-failed-icon',
      className: 'red-card',
      status: CARD_STATUS.RTB_WITHDRAWN,
      fromUserType: userType.CUSTOMER,
      cardMsg: STRINGS.RTB.RTB_WITHDRAWN_MSG,
    },
    itbCancelledCard: {
      //TID will be GIA_MYRA_CHAT_TID.RTB_WITHDRAWN
      iconSrcUrl: GuestChatIcons.BookingFailedIcon,
      iconAlt: 'request-cancelled',
      className: 'red-card',
      status: CARD_STATUS.RTB_CANCELLED,
      fromUserType: userType.HOST,
      cardMsg: STRINGS.RTB.RTB_CANCELLED_MSG,
    },
    [GIA_MYRA_CHAT_TID.ITB_SENT]: {
      iconSrcUrl: GuestChatIcons.PreApprovedInviteIcon,
      iconAlt: 'invite-sent-icon',
      className: 'orange-card',
      status: CARD_STATUS.ITB_SENT,
      fromUserType: userType.HOST,
      cardMsg: STRINGS.RTB.ITB_SENT_MSG,
    },
    [GIA_MYRA_CHAT_TID.ITB_WITHDRAWN]: {
      iconSrcUrl: GuestChatIcons.BookingFailedIcon,
      iconAlt: 'invite-withdrawn-icon',
      className: 'red-card',
      status: CARD_STATUS.ITB_WITHDRAWN,
      fromUserType: userType.HOST,
      cardMsg: STRINGS.RTB.ITB_WIDTHDRAWN_MSG,
    },
    [GIA_MYRA_CHAT_TID.ITB_EXPIRED]: {
      iconSrcUrl: GuestChatIcons.RequestExpiredMiniIcon,
      iconAlt: 'itb-expired-icon',
      className: 'grey-card',
      status: CARD_STATUS.ITB_EXPIRED,
      fromUserType: userType.CUSTOMER,
      cardMsg: STRINGS.RTB.ITB_EXPIRED_MSG,
    },
  };
};

export const BOOKING_STATUS_TYPES = [
  {
    label: 'Pending Booking Request',
    fieldPath: 'infoAttr.status',
    fieldValue: 'AWAITING HOST CONFIRMATION',
    value: 'PendingRtbRequest ',
    filterCountKey: 'open_rtb_pending',
  },
  {
    label: 'Expired Booking Request',
    fieldPath: 'infoAttr.status',
    fieldValue: 'REQUEST EXPIRED',
    value: 'ExpiredRtbRequest',
    filterCountKey: 'open_rtb_expired',
  },
  {
    label: 'Invite To Book',
    fieldPath: 'infoAttr.status',
    fieldValue: 'PRE-APPROVED BY HOST',
    value: 'InvitedToBook',
    filterCountKey: 'open_itb_sent',
  },
  {
    label: 'Invited Expired',
    fieldPath: 'infoAttr.status',
    fieldValue: 'INVITATION EXPIRED',
    value: 'InviteExpired',
    filterCountKey: 'open_itb_expired',
  },
  {
    label: 'Invited Withdrawn',
    fieldPath: 'infoAttr.status',
    fieldValue: 'INVITATION WITHDRAWN',
    value: 'InviteWithdrawn',
    filterCountKey: 'open_itb_withdrawn',
  },
];
